import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {REACH_USER_QUERY_KEY} from "../queryKeys";

type ReachUser = {
  email: string;
  full_name: string;
};

type Variables = {};

const getReachUser = async (): Promise<ReachUser> => {
  const response = await axiosReachInstance.get<ReachUser, AxiosResponse<ReachUser>>("/users/me");
  return response.data;
};

export const useGetReachUser = (options?: BaseQueryOptions<ReachUser, Variables>): BaseUseQueryResult<ReachUser> => {
  return useBaseQuery<ReachUser, Variables>([REACH_USER_QUERY_KEY, "me"], getReachUser, {}, options);
};
